import { parseJwt } from './parseJwt';

export type Token = {
  value: string;
  expirationTime: number;
};
export type Tokens = {
  auth?: Token;
  guest?: Token;
};

type User = {
  id: string;
  guest: boolean;
  token: string;
  isFamilyMember: boolean;
};

// Prefers logged in tokens, falls back to guest token
export const pickToken = ({ auth, guest }: Tokens): User => {
  if (auth && auth.value) {
    return {
      id: getPartyUId(auth.value),
      token: auth.value,
      guest: false,
      isFamilyMember: getIkeaFamilyStatus(auth.value),
    };
  }

  return {
    id: getUserId(guest?.value),
    token: guest?.value || '',
    guest: true,
    isFamilyMember: false,
  };
};

export const getTokens = (): Promise<Tokens> => {
  return new Promise<Tokens>((resolve, reject) => {
    const callback = (error: any, newTokens: Tokens) => {
      if (error) {
        reject(error);
      }
      resolve(newTokens);
    };

    if (window.ikea && window.ikea.authentication) {
      window.ikea.authentication.getTokens(callback);
    } else {
      reject('ikea.authentication is missing');
    }
  });
};

const getUserId = (token: string | undefined): string => {
  if (!token) {
    return '';
  }
  const payload = parseJwt(token);

  return payload['https://accounts.ikea.com/partyUId'] || payload.sub || '';
};

const getPartyUId = (token: string): string => {
  if (!token) {
    return '';
  }
  const authTokenJSON = parseJwt(token);
  return authTokenJSON['https://accounts.ikea.com/partyUId'] || '';
};

const getIkeaFamilyStatus = (token: string): boolean => {
  if (!token) {
    return false;
  }
  const payload = parseJwt(token);
  const loyaltyPrograms =
    payload['https://accounts.ikea.com/loyaltyPrograms'] ?? [];
  return (
    Array.isArray(loyaltyPrograms) && loyaltyPrograms.includes('IKEA_FAMILY')
  );
};
